import { savedTokens } from 'src/auth'
import { Aside, ErrorNotLoggedIn, Main } from 'src/components'

import { checkAdmin } from 'src/utils/validation'
import AdminOrganization from './Admin'
import ClientOrganization from './Client'

type Props = {
  organization: string
  username: string
}

function Organization(props: Props) {
  const isAdmin = checkAdmin(props.organization)

  return isAdmin ? (
    <AdminOrganization
      organization={props.organization}
      username={props.username}
    />
  ) : (
    <ClientOrganization
      organization={props.organization}
      username={props.username}
    />
  )
}

export default function ValidateOrganization() {
  const [tokens] = savedTokens.useState(null)

  if (!tokens) {
    return (
      <>
        <Aside title="Provisioning" hideExtraRow displayHelp />
        <Main>
          <ErrorNotLoggedIn />
        </Main>
      </>
    )
  }

  return (
    <Organization
      organization={tokens.organization}
      username={tokens.username}
    />
  )
}
